import { useOrganizationStore } from '../stores/useOrganizationStore';
import { ClientOwner, getClientOwner } from '../constants/clientOwners';
import { withStrategistCalendarLinks } from '../constants/strategistCalendar';

/**
 * Returns the Speculo team member assigned as the active org's Client Owner.
 * Falls back to the default (Ben) when no org is loaded or the field is unset.
 *
 * Use in any client-support surface (Schedule Call modal, crash-course banner,
 * flow strategy CTAs, etc.) so the displayed contact follows the org's
 * `client_owner` assignment. Its booking and strategy-meeting links already
 * account for any temporary calendar swap in effect today.
 */
export const useClientOwner = (): ClientOwner => {
  const clientOwner = useOrganizationStore((s) => s.organization?.client_owner);
  return withStrategistCalendarLinks(getClientOwner(clientOwner));
};
